import { Box, CircularProgress, Icon, Typography } from '@mui/material'
import React from 'react'
import { useQuery } from 'react-query'
import { inprogressParse } from 'services/api/modules/recruitment/external-talent'
import CancelRoundedIcon from '@mui/icons-material/CancelRounded'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'

const InprogressTab = ({ isOpen }) => {
  const { data = [], isLoading } = useQuery(
    'inprogressParse',
    async () => {
      const response = await inprogressParse()
      return response?.data || []
    },
    {
      enabled: !!isOpen,
    }
  )

  return (
    <Box>
      {isLoading ? (
        <Box
          sx={{
            width: '100%',
            height: '50vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress sx={{ color: 'alternate' }} />
        </Box>
      ) : data.length > 0 ? (
        <Box sx={{ height: 'calc(100vh - 100px)', overflowY: 'scroll' }}>
          {data.map((i, index) => (
            <Box key={index} sx={{ padding: '24px' }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: '20px',
                }}
              >
                <Typography fontWeight="bold">Batch {i.batch}</Typography>
                <Typography>Uploaded on {i.uploaded_at}</Typography>
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  borderRadius: '4.5px',
                  border: '1px solid #E5E5E5',
                }}
              >
                {i.resumes?.map((resume, resumeIndex) => (
                  <Box
                    key={resumeIndex}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '12px',
                      borderTop: resumeIndex !== 0 ? '1px solid #E5E5E5' : 'none',
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <Box
                        sx={{
                          width: '35px',
                          height: '35px',
                          borderRadius: '100%',
                          backgroundColor: 'default-background.main',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <Icon sx={{ color: 'alternate.main', fontSize: '20px' }}>
                          description
                        </Icon>
                      </Box>
                      <Typography>{resume.original_filename}</Typography>
                    </Box>

                    {resume.status === 1 ? (
                      <Box
                        sx={{
                          width: '100px',
                          display: 'flex',
                          alignItems: 'center',
                          color: 'warning.main',
                          gap: '8px',
                        }}
                      >
                        <CircularProgress size={20} sx={{ color: 'warning.main' }} />
                        <Typography>Parsing..</Typography>
                      </Box>
                    ) : resume.status === 4 ? (
                      <Box
                        sx={{
                          width: '100px',
                          display: 'flex',
                          alignItems: 'center',
                          color: 'light-gray-text.main',
                          gap: '8px',
                        }}
                      >
                        <CancelRoundedIcon sx={{ color: 'error.main' }} />
                        <Typography>Failed</Typography>
                      </Box>
                    ) : resume.status === 2 ? (
                      <Box
                        sx={{
                          width: '100px',
                          display: 'flex',
                          alignItems: 'center',
                          color: 'light-gray-text.main',
                          gap: '8px',
                        }}
                      >
                        <CheckCircleRoundedIcon sx={{ color: 'positive.main' }} />
                        <Typography>Parsed</Typography>
                      </Box>
                    ) : null}
                  </Box>
                ))}
              </Box>
            </Box>
          ))}
        </Box>
      ) : (
        <AdxEmptyStateV2
          icon={
            <Box sx={{ width: '36px', height: '36px' }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z"
                />
              </svg>
            </Box>
          }
          title="No parsing in progress"
        />
      )}
    </Box>
  )
}

export default InprogressTab